<script setup lang="ts">
import IconRank from '@/assets/IconRank.svg'
import UserAvatar from '@/assets/User-Avatar.svg'
import { computed } from 'vue'

const props = defineProps({
  rank: {
    type: Number,
    required: true
  },
  size: {
    type: Number,
    required: false
  }
})

const avatarClasses = computed(() =>
  props.size ? `w-[${props.size}px] h-[${props.size}px]` : 'w-8 h-8 md:w-12 md:h-12'
)

const rankClasses = computed(() =>
  props.size ? `w-[${props.size / 2}px] h-[${props.size / 2}px]` : 'w-4 h-4 md:w-6 md:h-6'
)
</script>

<template>
  <div class="relative h-auto w-auto">
    <user-avatar :class="avatarClasses" />

    <div class="absolute -bottom-1 -right-1 flex items-center justify-center text-white">
      <icon-rank :class="rankClasses" />
      <span class="absolute inset-0 flex items-center justify-center text-xs">
        {{ rank }}
      </span>
    </div>
  </div>
</template>
